// import React, { useId, useState } from 'react';
// import styled from 'styled-components';
// import { useSelector, useDispatch } from 'react-redux';
// import { useEffect } from 'react';

// import { getUsers,deactivateUser, adminManageUserStatus } from 'Features/api/api';
// import Spinner from 'SharedFns/SpinnerElement';

// import AssignRoleForm from '../Users/AssignRolesForm';
// import Modal from '../../SharedFns/Modal';

// import RemoveRoleForm from '../Users/RemoveUserRoles'; 
// import { baseURL } from 'SharedFns/Functions';

// import ChargeFineForm from '../accounting/ChargeFineForm';
// // import MemberShipStatusForm from './MembershipStatusForm';
// import MemberShipStatusForm from '../Users/MembershipStatusForm'; 
// // Sample data for members

// const members = [
//   {
//     id: 1,
//     firstName: 'John',
//     lastName: 'Doe',
//     regNumber: '12345',
//     title: 'Manager',
//     profilePic: 'https://via.placeholder.com/50'
//   },
//   {
//     id: 2,
//     firstName: 'Jane',
//     lastName: 'Smith',
//     regNumber: '67890',
//     title: 'Developer',
//     profilePic: 'https://via.placeholder.com/50'
//   }
//   // Add more members as needed
// ];



// const Directors = () => {
//     const dispatch=useDispatch()
//     useEffect( ()=>{
//         dispatch(getUsers())
//       }, [dispatch])
//     const [isModalOpen, setIsModalOpen]=useState(false)
//     const [isRemoveModalOpen, setIsRemoveModalOpen]=useState(false)
//     const [isChargeFineModalOpen, setISChargeFineModalOpen]=useState(false)
//     const [isMembershipStatusFormOpen, setIsMembershipStatusFormOpen]=useState(false)
//     const getFullPhotoUrl = (photo) => {
//       const baseUrl =baseURL // Adjust base URL as necessary
//     return baseUrl + photo;
//   };
//     const users=useSelector(state=> state.getUsers?.users?.users)
//     const isLoading=useSelector(state => state.getUsers?.loading)
//     const isActivateLoading=useSelector(state=>state.adminActivateUser?.loading || state.deactivateUser?.loading)
//     const is_active=useSelector(state=>state.getUsers?.users?.users.is_active )
//     const [selectedUserId, setSelectedUserId]=useState(null) 
//     const [selectedmember, setSelectedMember]=useState(null)
   
   
//    const statusCodeToName={
//     'pending_approval':'Pending Approval',
//     'active':'Active',
//     'dormant':'Dormant',
//     'cleared':'Cleared',

//    }
//     const handleDeactivate=(user_id)=>{
//       dispatch( deactivateUser({user_id}))

//     }
//     const handleMembershipStatus =  (user_id, member, e) => {
//       e.preventDefault();
//       setIsMembershipStatusFormOpen(true)
//       setSelectedMember(member)
//       setSelectedUserId(user_id)
//       console.log(user_id);
//   };
  
//     // const handleActivate=(user_id)=>{
//     //   dispatch( adminActivateUser({user_id}))

//     // }
//    const handleAssignRole=(userId)=>{
    
//     setIsModalOpen(true)
//     setSelectedUserId(userId)
//     console.log('The initial selected ID',userId)
//     console.log('The set selected ID',selectedUserId)
//       // dispatch( adminActivateUser({user_id}))

//     }
//     const handleRemoverole=(userId)=>{
     
//       setIsRemoveModalOpen(true)
//       setSelectedUserId(userId)
//         // dispatch( adminActivateUser({user_id}))
  
//       }

//       const handleFineUser=(userId)=>{
//         setISChargeFineModalOpen(true)
//         setSelectedUserId(userId)
//       } 
//   return (
    
//     <MemberListContainer>
//         <div>
//     { isLoading && <Spinner/>}
//     {isActivateLoading && <Spinner/>}
//     </div>
//     <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title='Assign role'>
//                 {<AssignRoleForm setIsModalOpen={setIsModalOpen} userId={selectedUserId} />}
//             </Modal> 
//             <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title='Remove role'>
//                 {<RemoveRoleForm setIsRemoveModalOpen={setIsRemoveModalOpen} userId={selectedUserId} />}
//             </Modal>    
//             <Modal isOpen={isChargeFineModalOpen} onClose={() => setISChargeFineModalOpen(false)} title='Fine member'>
//   <ChargeFineForm setISChargeFineModalOpen={setISChargeFineModalOpen} userId={selectedUserId} />
// </Modal>
//       <Modal isOpen={isMembershipStatusFormOpen} onClose={()=>setIsMembershipStatusFormOpen(false)} title='Change Status'>
//         <MemberShipStatusForm setIsMembershipStatusFormOpen={setIsMembershipStatusFormOpen} userId={selectedUserId} member={selectedmember}/>
//       </Modal>
//       {users?.map(member => (
//         <MemberCard key={member.id}>
//           <ProfilePic src={getFullPhotoUrl( member.photo)} alt={`${member.first_name}`} />
//           <MemberInfo>
//             <MemberName>{`${member.first_name} ${member.last_name}`}</MemberName>
//             <MemberDetails>ID: {member.id}</MemberDetails>
//             <MemberDetails>Reg Number: {member.reg_number}</MemberDetails>
//             <MemberDetails>Title: {member.user_groups[0]?member.user_groups[0]:'Member'}</MemberDetails>
//             <StatusDetail status={member.status}>Membership Status: {statusCodeToName[member.status]}</StatusDetail>
           
//           </MemberInfo>
//           {/* {member.is_active ?
//   <SignUpBtn onClick={() => handleDeactivate(member.id)}> Deactivate User</SignUpBtn> : <SignUpBtn onClick={() => handleActivate(member.id)}> Activate User</SignUpBtn>
// } */}
//           {member.user_groups[0]?<SignUpBtn onClick={()=>handleRemoverole(member.id)}>Remove Role</SignUpBtn>:<SignUpBtn onClick={()=> handleAssignRole(member.id)}>Assign Role</SignUpBtn>}
//           <SignUpBtn onClick={() => handleFineUser(member.id)}> Fine Member</SignUpBtn> 
//           <SignUpBtn onClick={(e) => handleMembershipStatus(member.id, member, e)}>Change Membership Status</SignUpBtn>

//         </MemberCard>
//       ))}
//     </MemberListContainer>
//   );
// };
// // Styled-components
// const MemberListContainer = styled.div`
// width:100%;
// height:80%;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content:flex-start;
//   overflow:scroll;
// `;

// const MemberCard = styled.div`
//   display: flex;
//   align-items: flex-start;
//   /* flex-direction:row; */
//   justify-content:flex-start;
//   background-color: #f8f9fa;
//   padding: 10px;
//   margin: 10px 0;
//   border-radius: 8px;
//   width: 80%;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//   @media (max-width:768px) {
//     flex-direction:column;
//     align-items:start;
//     margin-bottom:10px;
    
    
//   }
// `;

// const ProfilePic = styled.img`
//   border-radius: 50%;
//   width: 50px;
//   height: 50px;
//   margin-right: 20px;
// `;

// const MemberInfo = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// const MemberName = styled.div`
//   font-size: 18px;
//   font-weight: bold;
// `;

// const MemberDetails = styled.div`
//   font-size: 14px;
//   color: #666;
// `;
// const StatusDetail = styled.div`
//   font-size: 12px;
//   color: ${({ status }) => {
//     switch (status) {
//       case 'active':
//         return 'green';
//       case 'cleared':
//         return 'blue';
//       case 'dormant':
//         return 'red';
//       case 'pending_approval':
//         return  'orange'
//       default: 
//         return '#333';
//     }
//   }};
// `;
// const SignUpBtn = styled.button`
// margin-left:20px;
// display:flex;
// justify-content:flex-start;
// cursor:pointer;
// padding: 10px 30px;
// border-radius:10px;
// background-color:#E2725B;
// color:#f9f9f9;
// border:none;
// border-color:#E2725B;
// @media (max-width: 768px) {
//     font-size:10px;
//     padding: 5px 15px;
//     margin-left:2px;
//     margin-bottom:10px;
//     margin-top:10px;
// }
// `
// export default Directors;


import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import { getUsers } from 'Features/api/api';
import Spinner from 'SharedFns/SpinnerElement';
import AssignRoleForm from '../Users/AssignRolesForm';
import RemoveRoleForm from '../Users/RemoveUserRoles';
import ChargeFineForm from '../accounting/ChargeFineForm';
import MemberShipStatusForm from '../Users/MembershipStatusForm';
import Modal from '../../SharedFns/Modal';
import { baseURL } from 'SharedFns/Functions';

const statusCodeToName = {
  'pending_approval': 'Pending Approval',
  'active': 'Active',
  'dormant': 'Dormant',
  'cleared': 'Cleared',
};

const Directors = () => {
  const dispatch = useDispatch();
  const users = useSelector(state => state.getUsers?.users?.users);
  const isLoading = useSelector(state => state.getUsers?.loading);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const USERS_PER_PAGE = 6;

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isChargeFineModalOpen, setISChargeFineModalOpen] = useState(false);
  const [isMembershipStatusFormOpen, setIsMembershipStatusFormOpen] = useState(false);

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const filteredUsers = useMemo(() => {
    let filtered = users || [];
    if (statusFilter !== 'all') {
      filtered = filtered.filter(user => user.status === statusFilter);
    }
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(user => {
        const fullName = `${user.first_name || ''} ${user.last_name || ''}`.toLowerCase();
        const regNumber = (user.reg_number || '').toLowerCase();
        return fullName.includes(lowerSearch) || regNumber.includes(lowerSearch);
      });
    }
    
    return filtered;
  }, [users, statusFilter, searchTerm]);

  const totalPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * USERS_PER_PAGE, currentPage * USERS_PER_PAGE);

  const handleMembershipStatus = (userId, member, e) => {
    e.preventDefault();
    setIsMembershipStatusFormOpen(true);
    setSelectedUserId(userId);
    setSelectedMember(member);
  };

  return (
    <Container>
      {(isLoading) && <Spinner />}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Assign Role">
        <AssignRoleForm setIsModalOpen={setIsModalOpen} userId={selectedUserId} />
      </Modal>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Role">
        <RemoveRoleForm setIsRemoveModalOpen={setIsRemoveModalOpen} userId={selectedUserId} />
      </Modal>

      <Modal isOpen={isChargeFineModalOpen} onClose={() => setISChargeFineModalOpen(false)} title="Fine Member">
        <ChargeFineForm setISChargeFineModalOpen={setISChargeFineModalOpen} userId={selectedUserId} />
      </Modal>

      <Modal isOpen={isMembershipStatusFormOpen} onClose={() => setIsMembershipStatusFormOpen(false)} title="Change Status">
        <MemberShipStatusForm setIsMembershipStatusFormOpen={setIsMembershipStatusFormOpen} userId={selectedUserId} member={selectedMember} />
      </Modal>

      <FilterSection>
        <SearchInput
          type="text"
          placeholder="Search by name or reg number"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <Select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setCurrentPage(1); }}>
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="dormant">Dormant</option>
          <option value="pending_approval">Pending</option>
          <option value="cleared">Cleared</option>
        </Select>
      </FilterSection>

      <Grid>
        {paginatedUsers.map(member => (
          <Card key={member.id}>
            <TopRow>
              <Avatar src={baseURL + member.photo} />
              <Details>
                <Name>{member.first_name} {member.last_name}</Name>
                <Meta>ID: {member.id}</Meta>
                <Meta>Reg No: {member.reg_number}</Meta>
                <Meta>Role: {member.user_groups?.[0] || 'Member'}</Meta>
                <Status status={member.status}>{statusCodeToName[member.status]}</Status>
              </Details>
            </TopRow>
            <ActionRow>
              {member.user_groups?.[0] ? (
                <Action onClick={() => { setIsRemoveModalOpen(true); setSelectedUserId(member.id); }}>❌ Remove Role</Action>
              ) : (
                <Action onClick={() => { setIsModalOpen(true); setSelectedUserId(member.id); }}>➕ Assign Role</Action>
              )}
              <Action onClick={() => { setISChargeFineModalOpen(true); setSelectedUserId(member.id); }}>💰 Fine Member</Action>
              <Action onClick={(e) => handleMembershipStatus(member.id, member, e)}>🔄 Change Status</Action>
            </ActionRow>
          </Card>
        ))}
      </Grid>

      {totalPages > 1 && (
        <Pagination>
          {Array.from({ length: totalPages }).map((_, i) => (
            <PageButton
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              active={currentPage === i + 1}
            >
              {i + 1}
            </PageButton>
          ))}
        </Pagination>
      )}
    </Container>
  );
};

export default Directors;

// Styled Components

const Container = styled.div`
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  gap: 12px;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 200px;
  padding: 8px;
  font-size: 14px;
`;

const Select = styled.select`
  padding: 8px;
  font-size: 14px;
`;

const Grid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
`;

const Card = styled.div`
  background: #ffffff;
  padding: 16px 20px;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.01);
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
`;

const Avatar = styled.img`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.h4`
  margin: 0;
  font-size: 18px;
  color: #333;
`;

const Meta = styled.span`
  font-size: 13px;
  color: #666;
`;

const Status = styled.span`
  margin-top: 6px;
  font-size: 12px;
  color: ${({ status }) => {
    switch (status) {
      case 'active': return 'green';
      case 'cleared': return 'blue';
      case 'dormant': return 'red';
      case 'pending_approval': return 'orange';
      default: return '#999';
    }
  }};
`;

const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 10px;
`;

const Action = styled.button`
  background-color: #f1f1f1;
  border: none;
  color: #333;
  padding: 6px 14px;
  border-radius: 50px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background-color: #e2725b;
    color: white;
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 10px;
`;

const PageButton = styled.button`
  padding: 6px 12px;
  border: none;
  background: ${({ active }) => (active ? '#333' : '#ddd')};
  color: ${({ active }) => (active ? 'white' : '#333')};
  border-radius: 6px;
  cursor: pointer;
`;

